module.exports = __webpack_public_path__ + "static/img/20.9e7af04.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/eng/20.png
// module id = pYKA
// module chunks = 0